var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "mSaveCalcWritePremium",
        centered: "",
        "hide-footer": "",
        "hide-header": "",
      },
      on: {
        show: _vm.onShowModal,
        close: function ($event) {
          _vm.localActive = false
        },
      },
      model: {
        value: _vm.localActive,
        callback: function ($$v) {
          _vm.localActive = $$v
        },
        expression: "localActive",
      },
    },
    [
      _c("div", { staticClass: "m-write-premium" }, [
        _c(
          "svg",
          {
            staticClass: "m-write-premium-close",
            attrs: {
              width: "15",
              height: "16",
              viewBox: "0 0 15 16",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
            on: {
              click: function ($event) {
                _vm.localActive = false
              },
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                fill: "#8E9CBB",
              },
            }),
            _c("path", {
              attrs: {
                d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                fill: "#8E9CBB",
              },
            }),
          ]
        ),
        _c("div", { staticClass: "m-write-premium-title" }, [
          _vm._v(
            " " +
              _vm._s(
                _vm.editPremiumData ? "Редактировать премию" : "Выписать премию"
              ) +
              " "
          ),
        ]),
        _c("div", { staticClass: "m-write-premium-form" }, [
          _c(
            "div",
            { staticClass: "m-write-premium-form-row" },
            [
              _c("c-select", {
                staticClass: "m-write-premium-form-row-basis",
                class: {
                  "m-write-premium-form-row-basis-required":
                    _vm.basisErrorMessage.length > 0,
                },
                attrs: {
                  type: "select",
                  label: "Основание премии",
                  required: _vm.basisErrorMessage,
                  "required-condition": _vm.basisErrorMessage.length > 0,
                  searchable: true,
                  items: _vm.items,
                  groups: _vm.groups,
                  placeholder: "Выберите основание премии",
                },
                on: { input: _vm.setDefaultFineValue },
                model: {
                  value: _vm.basisLocalValue,
                  callback: function ($$v) {
                    _vm.basisLocalValue = $$v
                  },
                  expression: "basisLocalValue",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "m-write-premium-form-row",
              class: {
                "m-write-premium-form-row-required":
                  _vm.amountErrorMessage.length > 0,
              },
            },
            [
              _c("c-input", {
                staticClass: "m-write-premium-form-row-summ",
                class: {
                  "m-write-premium-form-row-summ-required":
                    _vm.amountErrorMessage.length > 0,
                },
                attrs: {
                  label: "Сумма, ฿",
                  "input-text-condition": _vm.amountErrorMessage,
                  placeholder: "0",
                  type: "integer-number",
                },
                model: {
                  value: _vm.amountLocal,
                  callback: function ($$v) {
                    _vm.amountLocal = $$v
                  },
                  expression: "amountLocal",
                },
              }),
              _c("c-input", {
                staticClass: "m-write-premium-form-row-author",
                attrs: {
                  label: "Автор премии",
                  items: _vm.authorsLocalItems,
                  searchable: true,
                  clearable: true,
                  type: "select",
                  placeholder: "Выберите автора премии",
                },
                model: {
                  value: _vm.authorLocalValue,
                  callback: function ($$v) {
                    _vm.authorLocalValue = $$v
                  },
                  expression: "authorLocalValue",
                },
              }),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "m-write-premium-actions" },
          [
            _c("c-button", {
              staticClass: "m-write-premium-actions-cancel",
              attrs: { size: "large", label: "Отменить" },
              on: { click: _vm.cancel },
            }),
            _c("c-button", {
              staticClass: "m-write-premium-actions-save",
              attrs: { label: "Сохранить", color: "primary", size: "large" },
              on: { click: _vm.submitForm },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }